import { routes } from "~/app/routes/web-routes.ts";
import { useCustomerSelection } from "~/shared/hooks/use-customer-selection.ts";
import type { Customer } from "~/shared/types/quote-details-types.ts";

export const useCommoditiesNavigation = () => {
	const result = useCustomerSelection({
		baseRoute: routes.commodities,
		customerRoute: routes.commoditiesWithCustomer,
	});

	const handleSelectCustomer = (customer: Customer | undefined) => {
		result.handleSelectCustomer(customer ?? null);
	};

	return {
		...result,
		handleSelectCustomer,
	};
};
